import UserRoleApi from "@/api/UserRoleApi";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    userBindRole(context, data) {
      return UserRoleApi.userBindRole(data);
    },
    userRoleList: (context, data) => UserRoleApi.userRoleList(data),
  },
};
